import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import './HelperWindows.css';

function ProductDetails() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check authentication on component mount
  useEffect(() => {
    if (!AuthService.isAuthenticated()) {
      // Redirect to main app for authentication
      window.location.href = '/';
      return;
    }
    
    setIsAuthenticated(true);
    setLoading(false);
    
    // Listen for logout events from other windows
    const handleLogout = () => {
      window.location.href = '/';
    };
    
    window.addEventListener('auth-logout', handleLogout);
    return () => window.removeEventListener('auth-logout', handleLogout);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    fetch('/data/products.json')
      .then(res => res.json())
      .then(data => {
        setProducts(data.products);
        setSelectedProduct(data.products[0]);
      })
      .catch(err => console.error('Failed to load products:', err));
  }, [isAuthenticated]);

  if (loading) {
    return (
      <div className="helper-window">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '200px',
          fontFamily: 'Arial, sans-serif'
        }}>
          Checking authentication...
        </div>
      </div>
    );
  }

  return (
    <div className="helper-window">
      <h1>Product Details</h1>
      
      <div className="product-selector">
        <select 
          value={selectedProduct?.product_id || ''} 
          onChange={(e) => setSelectedProduct(products.find(p => p.product_id === e.target.value))}
        >
          {products.map(product => (
            <option key={product.product_id} value={product.product_id}>
              {product.name}
            </option>
          ))}
        </select>
      </div>

      {selectedProduct && (
        <div className="product-content">
          <div className="product-header">
            <h2>{selectedProduct.name}</h2>
            <div className="product-type">{selectedProduct.type}</div>
          </div>

          <div className="product-section">
            <h3>Coverage Amounts</h3>
            <div className="coverage-amounts">
              {selectedProduct.coverage_amounts.map((amount, i) => (
                <span key={i} className="coverage-badge">{amount}</span>
              ))}
            </div>
          </div>

          {selectedProduct.term_lengths && (
            <div className="product-section">
              <h3>Term Lengths</h3>
              <div className="term-lengths">
                {selectedProduct.term_lengths.map((term, i) => (
                  <span key={i} className="term-badge">{term}</span>
                ))}
              </div>
            </div>
          )}

          <div className="product-section">
            <h3>Key Benefits</h3>
            <ul className="benefits-list">
              {selectedProduct.key_benefits.map((benefit, i) => (
                <li key={i}>{benefit}</li>
              ))}
            </ul>
          </div>

          <div className="product-section">
            <h3>Target Demographic</h3>
            <p>{selectedProduct.target_demographic}</p>
          </div>

          <div className="product-section">
            <h3>Ideal For</h3>
            <p className="ideal-for">{selectedProduct.ideal_for}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductDetails;
